const ReportExportButtonComponent = ({exportReport}) => {
    return (
        <div className="report-download" 
            onClick={() => { exportReport() }}>
            <svg id="Component_115_14" data-name="Component 115 â 14"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="45"
                height="45"
                viewBox="0 0 30 30">
                <defs>
                    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#415385" />
                        <stop offset="1" stop-color="#415385" />
                    </linearGradient>
                </defs>
                <circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)" />
                <circle id="Ellipse_179" data-name="Ellipse 179" cx="14" cy="13" r="14" transform="translate(1 2)" fill="#fff"></circle>
                <path id="database-export" d="M9.62,3C6.515,3,4,4.257,4,5.81S6.515,8.62,9.62,8.62c.351,0,.7-.021,1.054-.056v-1H12.7l-.7-.7,2.466-2.459A7.748,7.748,0,0,0,9.62,3m4.861,2.866-1,1L15.24,8.62H11.728v1.405H15.24l-1.756,1.756,1,1,3.456-3.456M4,7.215V9.323c0,1.553,2.515,2.81,5.62,2.81a10.5,10.5,0,0,0,2.283-.26l.794-.794H10.674V9.969c-.351.035-.7.056-1.054.056C6.515,10.025,4,8.768,4,7.215m0,3.513v2.108c0,1.553,2.515,2.81,5.62,2.81a7.748,7.748,0,0,0,4.847-1.405l-1.335-1.335a9.473,9.473,0,0,1-3.513.632C6.515,13.538,4,12.28,4,10.728Z" transform="translate(4.6 5.677)" fill="#415385" />
            </svg>
        </div>
    )
}

export default ReportExportButtonComponent;